import * as React from 'react';
import { Folder } from 'react-feather';
import { themeGet } from 'styled-system';
import { StyledSystemProps } from '../theme/StyledSystemProps';
import { theme } from '../theme';
import H3 from '../typography/H3';
import Box from '../components/primitives/Box';
import styled from 'styled-components';

type NoDataHandlerProps = StyledSystemProps & {
  color?: string;
  text?: string;
  size?: number;
};

const StyledBox = styled(Box)`
  border: 1px solid ${themeGet('colors.putty', '#000')};
`;

const NoDataHandler: React.FC<NoDataHandlerProps> = props => {
  return (
    <StyledBox {...props}>
      <Folder size={props.size || 100} color={theme.colors.putty} />
      <H3 mt={4} fontWeight={300}>
        {props.text || 'Sorry, there is currently no data to display.'}
      </H3>
    </StyledBox>
  );
};

export default NoDataHandler;

NoDataHandler.defaultProps = {
  height: '100%',
  borderRadius: '4px',
  m: 0,
  justifyContent: 'center',
  alignItems: 'center',
  px: 4,
  py: 5,
};



// WEBPACK FOOTER //
// ./src/components/NoDataHandler.tsx